import * as React from 'react';
import i18n from 'src/resources/i18n';

import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import ContentsCreateContainer from '../../containers/QuickModeContentsCreate';

/**
 * QuickMode-コンテンツ作成画面
 * @param props
 */
const QuickModeContentsCreate: React.FunctionComponent<any> = props => {
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('Rakunavi_Name')} />
			<ContentsCreateContainer />
		</>
	);
};

export default QuickModeContentsCreate;



// WEBPACK FOOTER //
// ./src/pages/quickMode/QuickModeContentsCreate.tsx